import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Course } from '../_models/Course';
import { IAppConfig } from '../lib/config/app-config';
import { APP_CONFIG } from '../lib/angular/injection-tokens';

@Injectable({
  providedIn: 'root',
})
export class PublicCourseService {
  private baseUrl: string = this.config.publicBaseUrl;
  private static readonly path: string = 'PublicCourse/';
  private static readonly screener: string = "screener/";
  constructor(private http: HttpClient, @Inject(APP_CONFIG) private config: IAppConfig) {}

  public getCourses$(): Observable<Course[]> {
    return this.http.get<Course[]>(this.baseUrl + PublicCourseService.path);
  }

  public getCoursesByLanguage$(langCode: string): Observable<Course[]> {
    return this.http.get<Course[]>(this.baseUrl + PublicCourseService.path + langCode);
  }

  public getCourseByEmail$(langCode: string, email: string): Observable<Course[]> {
    return this.http.post<Course[]>(
      `${this.baseUrl}${PublicCourseService.path}${PublicCourseService.screener}${langCode}`, 
      {
        email: email
      }
    );
  }
}
